/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit EnhancedContributions.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import ContributionFive from './ContributionFive/logic.js'
import ContributionFour from './ContributionFour/logic.js'
import ContributionOne from './ContributionOne/logic.js'
import ContributionThree from './ContributionThree/logic.js'
import ContributionTwo from './ContributionTwo/logic.js'
import Info from 'DesignSystem/Info/view.js'
import React from 'react'
import Title from 'DesignSystem/Title/view.js'
import { css } from "emotion"
ContributionFive.displayName = 'ContributionFiveLogic'
ContributionFour.displayName = 'ContributionFourLogic'
ContributionOne.displayName = 'ContributionOneLogic'
ContributionThree.displayName = 'ContributionThreeLogic'
ContributionTwo.displayName = 'ContributionTwoLogic'

let styles = {}
styles.Vertical = css({label: 'Vertical',
  width: 200,
height: 350,
paddingTop: 23,
paddingLeft: 50,
alignItems: "center"})

export default function EnhancedContributions({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  viewPath= "/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
}) {
    
    
    
    
    
    

  return (<React.Fragment
>
<div
 data-testid="EnhancedContributions.Vertical"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
 className={`views-block ${styles.Vertical}`}
>
<Title
 data-testid="EnhancedContributions.Title"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
viewPath={`${viewPath}/Title`}
 marginBottom={16}
 color="rgba(0,0,0, 0.3)"
 text="Enhanced"
/>
<Info
 data-testid="EnhancedContributions.Info"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
viewPath={`${viewPath}/Info`}
 text="Employer Contribution"
 marginBottom={12}
/>
<ContributionOne
 data-testid="EnhancedContributions.ContributionOne"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
viewPath={`${viewPath}/ContributionOne`}
/>
<ContributionTwo
 data-testid="EnhancedContributions.ContributionTwo"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
viewPath={`${viewPath}/ContributionTwo`}
/>
<ContributionThree
 data-testid="EnhancedContributions.ContributionThree"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
viewPath={`${viewPath}/ContributionThree`}
/>
<ContributionFour
 data-testid="EnhancedContributions.ContributionFour"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
viewPath={`${viewPath}/ContributionFour`}
/>
<ContributionFive
 data-testid="EnhancedContributions.ContributionFive"
 data-view-path="/App/MyAccount/Content/Profile/Content/MyCompanies/Item/Content/Change/EmployerContribution/Content/EnhancedContributions"
viewPath={`${viewPath}/ContributionFive`}
/>
</div>
{children}
</React.Fragment>)
}